// extracted by mini-css-extract-plugin
export default {"title":"ISUnderConstruction_title__F9HGd","text":"ISUnderConstruction_text__KGJrb","image":"ISUnderConstruction_image__dLHeA","anim":"ISUnderConstruction_anim__ZcPD+"};